import { OrdersCity } from 'modules/orders/types'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { axios } from '../../../lib'

type OrderCity = PaginatedParams & {
  stateId: string
}

const loadCustomerCities = (data: OrderCity): PaginatedResponse<OrdersCity> => {
  return axios.get(`/orders/generals/states/${data?.stateId}/cities`)
}

export function useLoadCustomerCities(query: OrderCity) {
  return useQuery(['customerCity', query], () => loadCustomerCities(query), {
    enabled: !!query.stateId,
    onError: () =>
      toast.error('Não foi possível carregar as cidades!', {
        toastId: 'loadCustomerCities'
      })
  })
}
